import React from 'react'

export default function SalesStyle({signed_in}) {
  let sales_report_buttons = null
  if (signed_in !== 'admin') {
    sales_report_buttons = {
      daily_sales_display: (signed_in.user_access.reports_sales_reports_daily_sales) ? 'flex' : 'none',
      monthly_sales_display: (signed_in.user_access.reports_sales_reports_monthly_sales) ? 'flex' : 'none',
      yearly_sales_display: (signed_in.user_access.reports_sales_reports_yearly_sales) ? 'flex' : 'none',
      receivables_display: (signed_in.user_access.reports_sales_reports_receivables) ? 'flex' : 'none'
    }
  } else {
    sales_report_buttons = { daily_sales_display: 'flex', monthly_sales_display: 'flex', yearly_sales_display: 'flex', receivables_display: 'flex' }
  }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        :root { --light: #555; }

        .report-item-container {
          display: 'flex';
          flex-direction: column;
          font-size: 1rem;
          padding: 10px;
        }

        .report-item-header {
          display: flex;
          background-color: lightgreen;
          padding: 10px;
          margin: auto;
          margin-left: 0;
          font-size: 1rem;
          box-sizing: border-box;
          justify-content: stretch;
          width: 100%;
          border: none;
        }
        .report-item-header:hover {
          background-color: rgb(95, 240, 59);
          cursor: pointer;
        }

        .report-items-container {
          /*
          background-color: yellow;
          display: flex;
          padding: 10px;
          */

          /*border-left: solid 1px lightgreen;*/
          border: solid 1px lightgreen;
          border-top: none;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          overflow: auto;
          padding: 30px 30px;
        }

        .hide-ric { display: none; }

        /*
        .report-item {
          border: none;
          background-color: lightskyblue;
          display: flex;
          flex-direction: column;
          margin: 10px;
        }
        */

        .report-item-wrapper {
          border: none;
          background-color: lightskyblue;
          display: flex;
          flex-direction: column;
          margin: 10px;
        }
        .report-item-title, .report-item-description {
          padding: 10px;
        }
        .report-item-title { font-size: 1.2rem; }
        .report-item-description {
          font-size: 0.95rem;
          color: var(--light, #555);
        }

        .report-item-wrapper:hover, .report-item-wrapper:focus {
          /* let's change the ---light here so settings-item-description is also affected by hover */
          transform: scale(1.0003);
          box-shadow: 1px 1px 2px 1px #BBB;
          border: none;
          background-color: blue;
          color: white;
          outline: none;
          --light: white;
        }

        /** Reports Buttons **/
        #daily-sales-btn { display: ${sales_report_buttons.daily_sales_display}; }
        #monthly-sales-btn { display: ${sales_report_buttons.monthly_sales_display}; }
        #yearly-sales-btn { display: ${sales_report_buttons.yearly_sales_display}; }
        #receivables-btn { display: ${sales_report_buttons.receivables_display}; }

      `}
      </style>
    </React.Fragment>
  )
}
